import { FC } from 'react';

import { useRecoilValue } from 'recoil';

import { showSideMenuAtom } from '@recoil_iqfu/atoms/side_menu/showSideMenu';

import styles from './ConsoleChatMainContainer.module.scss';
const ConsoleChatMainContainer: FC = ({ children }) => {
  const showSideMenu = useRecoilValue(showSideMenuAtom);
  return <div className={`${styles.container} ${!showSideMenu ? styles.hides_side_menu : ''}`}>{children}</div>;
};

export default ConsoleChatMainContainer;
